import styled from "styled-components";

export const Styles = styled.div`
  .activity {
    margin-top: 50px;
  }
  #main {
    &.main-result {
      background: #111423;
      .section-result {
        /* min-height:1080px; */
        padding: 0;
        background: #111423;
        color: #fff;
        .title {
          margin: 40px 0 100px 0;

          h4 {
            text-transform: uppercase;
            color: #fff;
            font-weight: 700;
            font-size: 48px;
            text-align: center;
            margin: 0;
          }
          h6 {
            text-transform: uppercase;
            color: #1f2839;
            font-size: 48px;
            font-weight: 700;
            text-align: center;
            padding-top: 15px;
            margin: 0;
            padding-bottom: 85px;
            background: linear-gradient(94.08deg, #a15bff 0%, #ff8a5a 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
        }
        .top-rank {
          max-width: 90%;
          margin: 0 auto;
          display: flex;
          grid-template-columns: 30% 40% 30%;
          justify-content: center;
          gap: 30px;
          .rank-item {
            &.item2 {
              margin-top: -150px;
            }
          }
          @media screen and (max-width: 991px) {
            max-width: 100%;
            gap: 15px;
          }
          /* @media screen and (max-width: 768px) {
            max-width: 100%;
            gap: 15px;
          } */

          @media only screen and (max-width: 767px) {
            display: flex;
            flex-direction: column;
            max-width: 70%;

            #rank-1 {
              order: 1;
            }
            #rank-2 {
              order: 2;
            }
            #rank-3 {
              order: 3;
            }

            .top-2 {
              /* margin-top: 50px !important; */
            }

            .top-3 {
              /* margin-top: 50px !important; */
            }
          }
          @media screen and (max-width: 479px) {
            max-width: 85%;
            gap: 15px;
          }

          /* .item-rank{
                            width:200px;
                        } */
          /* .top-2 {
            margin-top: 50px;
          } */
        }
        .rest-rank {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 40px 30px;
          margin-top: 50px;
          padding: 20px 0;
          > * {
            width: 23%;
          }

          #rank-1 {
            margin-top: 0;
          }

          @media only screen and (max-width: 1199px) {
            > * {
              width: unset;
            }
          }
          @media only screen and (max-width: 992px) {
            margin-top: 40px;
          }
        }
        @media only screen and (max-width: 992px) {
          .title {
            h4 {
              font-size: 36px;
              margin: 10px 0;
            }
            h6 {
              font-size: 36px;
              padding-top: 0px;
              padding-bottom: 50px;
            }
          }
        }
        @media only screen and (max-width: 767px) {
          .title {
            margin: 40px 0 60px 0;
            h4 {
              font-size: 28px;
              margin: 10px 0;
            }
            h6 {
              font-size: 28px;
              padding-bottom: 0px;
            }
          }
        }
        @media only screen and (max-width: 576px) {
          .title {
            margin: 40px 0;
            h4 {
              font-size: 22px;
              margin: 6px 0;
            }
            h6 {
              font-size: 22px;
              margin-top: 8px;
              padding-bottom: 0px;
            }
          }
        }
      }
    }
  }
`;
